import { client } from '../client';
import { getStaffScopedApiPrefix } from '../../Utils/staffScopedApiPrefix';
import { Dependent } from './types/Dependent';
import { UserRoleName } from './types/UserProfile';

export type UpdateDependentPayload = {
  guardian_relationship: string;
  email: string | null;
};

export type UpdateDependentOptions = {
  /** @deprecated Use userRole. */
  collectorManaged?: boolean;
  userRole?: UserRoleName | string;
};

export const updateDependent = async (
  user_id: number,
  dependent_id: number,
  payload: UpdateDependentPayload,
  options?: UpdateDependentOptions,
): Promise<Dependent> => {
  const prefix = options?.collectorManaged
    ? '/collector'
    : getStaffScopedApiPrefix(options?.userRole);
  const path = `${prefix}/users/${user_id}/dependents/${dependent_id}`;
  const { data } = await client.patch(path, payload);

  return data;
};
